import { render } from "./secondUploadStock.vue?vue&type=template&id=2bdba1ae&scoped=true"
import script from "./secondUploadStock.vue?vue&type=script&lang=js"
export * from "./secondUploadStock.vue?vue&type=script&lang=js"

import "./secondUploadStock.vue?vue&type=style&index=0&id=2bdba1ae&scoped=true&lang=css"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bdba1ae"]])

export default __exports__